// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightMiniReport-cls1_kEs","cls2":"CiterightMiniReport-cls2_Tq8 CiterightMiniReport-cls1_kEs"};